import { BillType } from '@/@types/bill.types';
import { createMachine } from 'xstate';

const fundingRequestDetailsFlow = {
  id: 'newBnplPayment',
  initial: 'flow',
  states: {
    flow: {
      initial: 'chooseFundingRequestType',
      states: {
        chooseFundingRequestType: {
          on: {
            NEXT: [
              { target: 'bnplPaymentSchedule', cond: 'isCashAdvanceFlow' },
              { target: 'uploadInvoice' },
            ],
            RESET: 'chooseFundingRequestType',
          },
        },
        uploadInvoice: {
          on: {
            NEXT: 'bnplPaymentSchedule',
            PREVIOUS: 'chooseFundingRequestType',
            RESET: 'chooseFundingRequestType',
          },
        },
        bnplPaymentSchedule: {
          on: {
            NEXT: [
              {
                target: 'bnplPaymentScheduleConfirmation',
                cond: 'isCashAdvanceFlow',
              },
              { target: 'invoiceDetailsForm' },
            ],
            PREVIOUS: [
              { target: 'chooseFundingRequestType', cond: 'isCashAdvanceFlow' },
              { target: 'uploadInvoice' },
            ],
            RESET: 'chooseFundingRequestType',
          },
        },
        invoiceDetailsForm: {
          on: {
            NEXT: [
              {
                target: 'beneficiaryDetails',
                cond: 'isNewBeneficiary',
              },
              { target: 'bnplPaymentScheduleConfirmation' },
            ],
            PREVIOUS: 'bnplPaymentSchedule',
            RESET: 'chooseFundingRequestType',
          },
        },
        beneficiaryDetails: {
          on: {
            NEXT: 'bnplPaymentScheduleConfirmation',
            PREVIOUS: 'invoiceDetailsForm',
            RESET: 'chooseFundingRequestType',
          },
        },
        bnplPaymentScheduleConfirmation: {
          on: {
            NEXT: [{ target: 'paymentAdded' }],
            PREVIOUS: [
              {
                target: 'beneficiaryDetails',
                cond: 'isNewBeneficiary',
              },
              { target: 'bnplPaymentSchedule', cond: 'isCashAdvanceFlow' },
              { target: 'invoiceDetailsForm' },
            ],
            RESET: 'chooseFundingRequestType',
          },
        },
        paymentAdded: {
          on: {
            RESET: 'chooseFundingRequestType',
            GO_TO_BENEFICIARY_DETAILS: 'beneficiaryDetails',
          },
        },
        hist: { type: 'history' },
      },
      on: { EXIT: 'exitFlow' },
    },
    exitFlow: {
      on: { GIVE_UP: 'flow.hist', RESET: 'flow.chooseFundingRequestType' },
    },
  },
};

const guards = {
  isNewBeneficiary: (_, query) => query.isNewBeneficiary,
  isCashAdvanceFlow: (_, query) => query.billFlowType === BillType.CASH_ADVANCE,
};

const getPaymentStateMachine = () => {
  return createMachine(fundingRequestDetailsFlow, { guards });
};

export { getPaymentStateMachine };
